import { useState } from 'react';
import { Card, Form, Input, Button, Typography, Alert, Space } from 'antd';
import { useAuth } from '@/lib/auth';
import { useNavigate, useLocation } from 'react-router-dom';

const { Title } = Typography;

export function LoginPage() {
  const { sendCode, verifyCode } = useAuth();
  const nav = useNavigate();
  const loc = useLocation() as { state?: { from?: string } };
  const [stage, setStage] = useState<'email' | 'code'>('email');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function onSendCode() {
    setBusy(true);
    setErr(null);
    try {
      await sendCode(email);
      setStage('code');
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  async function onVerify(values: { code: string }) {
    setBusy(true);
    setErr(null);
    try {
      await verifyCode(email, values.code);
      nav(loc.state?.from ?? '/topics', { replace: true });
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f5f5f5' }}
    >
      <Card style={{ width: 380 }}>
        <Title level={3} style={{ marginTop: 0 }}>
          GMCC Admin
        </Title>
        {err && (
          <Alert
            type="error"
            message={err}
            style={{ marginBottom: 12 }}
            closable
            onClose={() => setErr(null)}
          />
        )}
        {stage === 'email' ? (
          <Form layout="vertical" onFinish={onSendCode}>
            <Form.Item label="Email" required>
              <Input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                autoComplete="email"
                autoFocus
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" loading={busy} block disabled={!email}>
              Send sign-in code
            </Button>
          </Form>
        ) : (
          <Form layout="vertical" onFinish={onVerify}>
            <Form.Item
              label={`Code sent to ${email}`}
              name="code"
              rules={[{ required: true, len: 6 }]}
            >
              <Input maxLength={6} autoComplete="one-time-code" autoFocus />
            </Form.Item>
            <Space>
              <Button onClick={() => setStage('email')}>Back</Button>
              <Button type="primary" htmlType="submit" loading={busy}>
                Sign in
              </Button>
            </Space>
          </Form>
        )}
      </Card>
    </div>
  );
}
